(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/param-parser.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/param-parser.js');

'use strict';

function closestDraw(product) {
  const [first] = svs.numbergames.draws.drawsUtils.sortProductsByDrawTime(product);
  return first ? [first.productItsId] : [];
}
svs.numbergames.game_model.utils.paramParser = () => {
  const RETURN_OBJECT = {};
  const FUNCTION_MAP = {};
  const rules = svs.numbergames.game_model.rulesRadio.request('rules');
  const SUBSCRIPTION_PARAM = 'prenumerera';
  const SUBSCRIPTION_VALUE = 'subscription';
  const PARAM_MAP = {
    ROWS: 'rader',
    JOKER: 'joker',
    DAY: 'dag',
    MULTI: 'multi',
    DRAW_COUNT: 'dragningar'
  };
  const {
    EUROJACKPOT,
    EUROJACKPOT_TUESDAY,
    EUROJACKPOT_FRIDAY,
    LOTTO,
    LOTTO_WEDNESDAY,
    LOTTO_SATURDAY
  } = svs.numbergames.productMapping.CONSTANTS;
  FUNCTION_MAP[PARAM_MAP.ROWS] = value => {
    value = parseInt(value, 10);
    if (value > 0 && value <= rules.maxNumberOfRows) RETURN_OBJECT.preHuxfluxed = value;
  };
  FUNCTION_MAP[PARAM_MAP.JOKER] = value => {
    if (rules.usesJoker) {
      value = parseInt(value, 10);
      const validPricesArray = svs.numbergames.rules.joker.getJokerPrices();
      if (validPricesArray.indexOf(value) > -1) {
        RETURN_OBJECT.hasJoker = Boolean(value);
        RETURN_OBJECT.jokerPrice = value;
      }
    }
  };
  FUNCTION_MAP[PARAM_MAP.DAY] = value => {
    var _days$value;
    const dayMaps = {
      [EUROJACKPOT]: {
        b: [EUROJACKPOT_TUESDAY, EUROJACKPOT_FRIDAY],
        t: [EUROJACKPOT_TUESDAY],
        f: [EUROJACKPOT_FRIDAY],
        n: closestDraw(EUROJACKPOT)
      },
      [LOTTO]: {
        b: [LOTTO_WEDNESDAY, LOTTO_SATURDAY],
        o: [LOTTO_WEDNESDAY],
        l: [LOTTO_SATURDAY],
        n: closestDraw(LOTTO)
      }
    };
    const days = dayMaps[rules.productId];
    if (days !== null && days !== void 0 && (_days$value = days[value]) !== null && _days$value !== void 0 && _days$value.length) {
      RETURN_OBJECT.selectedDays = days[value];
    }
  };
  FUNCTION_MAP[PARAM_MAP.MULTI] = value => {
    var _rules$rowPriceMulti;
    value = parseInt(value, 10);
    if (value === 1 || ((_rules$rowPriceMulti = rules.rowPriceMulti) === null || _rules$rowPriceMulti === void 0 ? void 0 : _rules$rowPriceMulti.indexOf(value)) > -1) RETURN_OBJECT.rowPriceMulti = value;
  };
  FUNCTION_MAP[PARAM_MAP.DRAW_COUNT] = value => {
    if (value === SUBSCRIPTION_PARAM) {
      RETURN_OBJECT.drawCount = SUBSCRIPTION_VALUE;
    }
    if (rules.possibleDrawCounts.find(draw => draw.value === value)) {
      RETURN_OBJECT.drawCount = value;
    }
  };
  let analyticsAction = '';
  Object.keys(PARAM_MAP).forEach(key => {
    key = PARAM_MAP[key];
    const {
      value
    } = svs.utils.paramHandler.get({
      key
    });
    if (value) {
      var _FUNCTION_MAP$key;
      analyticsAction = "".concat(analyticsAction).concat(key, "=").concat(value, ";");
      svs.utils.paramHandler.remove({
        key
      });
      (_FUNCTION_MAP$key = FUNCTION_MAP[key]) === null || _FUNCTION_MAP$key === void 0 || _FUNCTION_MAP$key.call(FUNCTION_MAP, value);
    }
  });
  if (analyticsAction.length) {
    const analyticsEvent = {
      category: 'Dynamic Link',
      action: analyticsAction
    };
    svs.components.analytics.trackEvent(analyticsEvent);
  }
  return RETURN_OBJECT;
};

 })(window);